<template>
   <section class="why-matters">
        <h2 class="section-title">You Shouldn't Have to Choose Between<br>Running Your Business and Growing It</h2>
        <div class="three-column">
            <div class="benefit-card">
                <div class="benefit-icon">🎯</div>
                <h3>Stay Focused</h3>
                <p>While Pabu handles inquiries and bookings, you do what you love—bake, create, serve.</p>
            </div>
            <div class="benefit-card">
                <div class="benefit-icon">📊</div>
                <h3>See Clearly</h3>
                <p>Know what's working without spending hours in spreadsheets. Pabu spots patterns you'd miss.</p>
            </div>
            <div class="benefit-card">
                <div class="benefit-icon">💪</div>
                <h3>Decide Confidently</h3>
                <p>Get insights backed by your data and industry expertise. You make the call, with better information.</p>
            </div>
        </div>
    </section>
</template>
  
  <script>
  export default {
    name: "WhyThisMattersSection"
    /*
    data() {
      return {
        benefits: [
          { number: "01", title: "Personalized Support", text: "We tailor our services to meet individual needs, promoting independence and dignity." },
          { number: "02", title: "Compassionate & Skilled Team", text: "Our experienced professionals provide care with empathy, respect, and dedication." },
          { number: "03", title: "Reliable & Accessible Services", text: "Whether at home or in the community, we’re here when you need us most." },
          { number: "04", title: "Empowering Lives", text: "We foster inclusion, social participation, and opportunities for individuals to thrive." }
        ]
      };
    }*/
  };
  </script>
  
  <style scoped>


  </style>
  